
import { defineComponent } from 'vue';
import RoundedIconAndText from '@/components/ui-components/RoundedIconAndText.vue';
import BorderedIconButton from '@/components/ui-components/BorderedIconButton.vue';
import { AccountAction } from '@/modules/Account/store/actions-types';
import { AUTH } from '@/modules/Auth/store/mutation-types';
import { DEMANDE_DEVIS } from '@/modules/DemandeDevis/store/mutation-types';
import { DEMANDE_INTERVENTION } from '@/modules/DemandeIntervention/store/mutation-types';
import { DEVIS } from '@/modules/Devis/store/mutation-types';
import { SUIVI_INTERVENTION } from '@/modules/SuiviInterventions/store/mutation-types';
import { HomeAction } from '@/modules/Home/store/actions-types';
import { INTERVENTION } from '@/modules/Intervention/store/mutation-types';
import { SUIVI_FACTURES } from '@/modules/SuiviFactures/store/mutation-types';
import { PREVENTIF } from '@/modules/Preventif/store/mutation-types';
import { SUIVI_RECLAMATION } from '@/modules/SuiviReclamation/store/mutation-types';
import { DOCUMENT_REGLEMENTAIRE } from '@/modules/DocumentReglementaire/store/mutation-types';
import { OPTIONS_SUIVI } from '@/modules/OptionsSuiviInterventions/store/mutation-types';
import OptionSuiviModale from '@/modules/OptionsSuiviInterventions/components/OptionSuiviModale.vue';
import { store } from '@/plugins/store';
import { MON_COMPTE } from '@/modules/MonCompte/store/mutation-types';
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import { ACCOUNT } from '@/modules/Account/store/mutation-types';
import { HOME } from '@/modules/Home/store/mutation-types';
import MonCompteModale from '@/modules/MonCompte/components/MonCompteModale.vue';
import PreavisInterventionModale from '@/modules/PreavisIntervention/pages/PreavisInterventionModale.vue';
import { PREAVIS } from '@/modules/PreavisIntervention/store/mutation-types';
import { msalInstance } from '@/authenticationConfig';
import { useMsal } from '@/common/utils/useMsal';
import { Langue } from '@/modules/Home/store/state';
import AppInfoModale from '@/modules/AppInfo/components/AppInfoModale.vue';
import { REGLES_GESTION as ReglesGestionMutations } from '@/modules/ReglesGestion/store/mutation-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

const __default__ = defineComponent({
    name: 'MainHeader',
    props: {
        connected: {
            type: Boolean,
        },
    },
    components: {
        MonCompteModale,
        RoundedIconAndText,
        BorderedIconButton,
        ReglePastille,
        OptionSuiviModale,
        PreavisInterventionModale,
        AppInfoModale,
    },
    computed: {
        loadIconIntervention() {
            return require('@/assets/img/menu/outils.png');
        },
        loadIconAppInfo() {
            return require('@/assets/img/info_24dp.png');
        },
        loadIconReglesGestion(): string {
            return this.reglesGestionActif
                ? require('@/assets/img/toggle-on.svg')
                : require('@/assets/img/toggle-off.svg');
        },
        reglesGestionActif(): boolean {
            return this.$store.getters['reglesGestionState/isActif'];
        },
        envActuel(): string {
            return window.CONFIG?.env || '';
        },
        envAutoriseReglesGestion(): boolean {
            return ['DEV', 'INT', 'REC'].includes(this.envActuel.toUpperCase());
        },
        autoriseReglesGestion(): boolean {
            return (
                this.envAutoriseReglesGestion &&
                !!store.getters.getUserInformations?.fonctions.includes('acces.reglesmetier')
            );
        },
        envCouleur(): string {
            switch (window.CONFIG?.env) {
                case 'DEV':
                    return 'var(--env-dev)';
                case 'INT':
                    return 'var(--env-int)';
                case 'REC':
                    return 'var(--env-rec)';
                default:
                    return 'transparent';
            }
        },
        loadIconDevis() {
            return require('@/assets/img/menu/calculate.png');
        },
        loadIcon() {
            return require('@/assets/img/logo.svg');
        },
        isModaleOptionsSuiviOpen() {
            return store.state.optionsSuiviInterventionState.isModaleOpen;
        },
        isModaleMonCompteOpen() {
            return store.state.monCompteState.isModaleOpen;
        },
        isModalePreavisOpen() {
            return store.state.preavisInterventionState.isModaleOpen;
        },
        login() {
            return localStorage.getItem('login');
        },
        isPortailClient(): boolean {
            return this.$router.currentRoute.value.meta.droit !== 'role.fournisseur';
        },
        isClient(): boolean {
            return localStorage.getItem('isClient') === 'true';
        },
        getImageDrapeauLangueSelectionnee(): string {
            const langueSelectionnee = this.$store.getters.getLangueSelectionnee;
            if (langueSelectionnee != null) {
                return this.getImageDrapeauLangue(langueSelectionnee.id);
            }
            return '';
        },
        getLanguesdisponibles(): Langue[] {
            return this.$store.getters.getLanguesDisponibles;
        },
        getArrowDown() {
            return require('@/assets/img/arrow_drop_down.png');
        },
        getArrowUp() {
            return require('@/assets/img/arrow_drop_up_24.png');
        },
    },
    data() {
        const instance = useMsal();
        return {
            showMyAccountMenu: false,
            instance: instance,
            logos: [] as { id: number; src: string }[],
            logosInexistant: [14, 23, 33, 57, 10, 80, 40, 31, 54, 58, 38] as number[],
            modaleChoixLangueOuverte: false,
            isModaleAppInfoOpen: false,
        };
    },
    async mounted() {
        if (this.connected) {
            this.$store.dispatch(AccountAction.GET_SOCIETES, true).then(() => {
                // il n'y a pas de logo de Henelia (23), Financière Hervé (33), Cel (57), STES CIVILES IMMOBILIERES(10), CONSORTIUM SUISSE(80), ENTREPRISE SMC(40)
                // Billon(14) a fusionné avec Hervé Thermique
                // Mantis 47798 : Retirer logos effet d'o (31), herve belgium (54) et groupe solyos (58)
                this.logos = this.$store.getters.getSocieteIds
                    .filter((id: number) => !this.logosInexistant.includes(id))
                    .map((id: number) => {
                        return {
                            id: id,
                            src: window.CONFIG.logosUrl + id + '.png',
                        };
                    });
            });
        }
        await this.getLangues();
        this.getLangueSelectionnee();
        this.getTraductions();
    },
    methods: {
        openAppInfoModale() {
            this.isModaleAppInfoOpen = true;
        },
        basculerReglesGestion() {
            const actif = this.$store.getters['reglesGestionState/isActif'];
            this.$store.commit(`reglesGestionState/${ReglesGestionMutations.SET_ACTIF}`, !actif);
        },
        closeAppInfoModale() {
            this.isModaleAppInfoOpen = false;
        },
        goIntervention() {
            this.$router.push('/intervention');
        },
        goDevis() {
            this.$router.push('/devis');
        },
        async disconnect() {
            if (localStorage.getItem('botActive') === 'true') {
                window['ideta_bot_action']('remove');
            }
            this.$store.commit(`suiviDemandeInterventionModuleState/${DEMANDE_INTERVENTION.CLEAR_ALL}`);
            this.$store.commit(`suiviInterventionModuleState/${SUIVI_INTERVENTION.CLEAR_ALL}`);
            this.$store.commit(DEMANDE_DEVIS.CLEAR_ALL);
            this.$store.commit(DEVIS.CLEAR_ALL);
            this.$store.commit(AUTH.CLEAR_TOKEN);
            this.$store.commit(INTERVENTION.CLEAR_ALL);
            this.$store.commit(`suiviFacturesModuleState/${SUIVI_FACTURES.CLEAR_ALL}`);
            this.$store.commit(`siteList/${SITE_LIST.RESET}`);
            this.$store.commit(`accountModule/${ACCOUNT.RESET}`);
            this.$store.commit(`homeState/${HOME.RESET}`);
            this.$store.commit(PREVENTIF.RESET);
            this.$store.commit(SUIVI_RECLAMATION.RESET);
            this.$store.commit(`documentReglementaireState/${DOCUMENT_REGLEMENTAIRE.RESET}`);
            this.$store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.RESET}`);
            this.$store.commit(`monCompteState/${MON_COMPTE.RESET}`);
            this.$store.commit(`preavisInterventionState/${PREAVIS.RESET}`);
            this.$store.dispatch(HomeAction.RESET_MODULES);
            localStorage.removeItem('token_portail_partenaire');
            localStorage.removeItem('token_azure');
            localStorage.removeItem('token');
            localStorage.removeItem('login');
            localStorage.removeItem('redirectAfterLogin');
            localStorage.removeItem('nom');
            localStorage.removeItem('tokenAzure');
            localStorage.removeItem('prenom');
            localStorage.removeItem('email');
            localStorage.setItem('botActive', 'false');
            await msalInstance.clearCache();
            await msalInstance.setActiveAccount(null);
            await msalInstance.handleRedirectPromise().catch(error => {
                console.error(error);
            });
            // On se déconnecte d'Azure
            const logoutRequest = {
                account: msalInstance.getActiveAccount(),
            };

            localStorage.removeItem('redirectAfterLogin');

            // On redirige vers la page d'authentification
            console.info('[MenuPage] logoutRedirect');
            await this.instance.logoutRedirect(logoutRequest);
            localStorage.removeItem('token_portail_partenaire');
            localStorage.removeItem('token');
            this.$router.replace('/');
        },
        openOptionsSuiviModale() {
            this.$store.commit(`optionsSuiviInterventionState/${OPTIONS_SUIVI.SET_MODAL}`, true);
        },
        openMonCompteModale() {
            this.$store.commit(`monCompteState/${MON_COMPTE.SET_MODAL}`, true);
        },
        openPreavisInterventionModale() {
            this.$store.commit(`preavisInterventionState/${PREAVIS.SET_MODAL}`, true);
        },
        openNav() {
            this.showMyAccountMenu = true;
        },
        closeNav() {
            this.showMyAccountMenu = false;
        },
        checkDroitSubRoute(droit: string): boolean {
            return store.getters.getUserInformations?.fonctions.includes(droit);
        },
        ouvrirFermerModaleChoixLangue() {
            this.modaleChoixLangueOuverte = !this.modaleChoixLangueOuverte;
        },
        getImageDrapeauLangue(langueId: number): string {
            return require('@/assets/img/drapeaux/' + langueId + '.png');
        },
        async setLangue(langueId: number) {
            await this.$store.dispatch(HomeAction.SET_LANGUE, langueId);
            this.ouvrirFermerModaleChoixLangue();
            await this.$store.dispatch(HomeAction.GET_TRADUCTIONS);
            this.$router.go(0);
        },
        async getLangues(): Promise<void> {
            await this.$store.dispatch(HomeAction.GET_LANGUES);
        },
        getLangueSelectionnee(): void {
            this.$store.dispatch(HomeAction.GET_LANGUE_SELECTIONNEE);
        },
        getTraductions(): void {
            this.$store.dispatch(HomeAction.GET_TRADUCTIONS);
        },
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v31ae0797": (_ctx.envCouleur)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__